<template>
    <div>
        <div v-if="mode !== 'sub_heading'" style="width: fit-content">
            <div :class="`form-group vue-radio-checkbox ${mode} np-checkbox`" v-if="noWrapper">
                <input type="checkbox"
                       :checked="is_checked"
                       :value="value"
                       :id="id"
                       ref = 'input'
                       :name="name"
                       :disabled="disabled"
                       :required="isRequired"
                       :readonly="readonly"
                       v-bind="$attrs"
                       @change="doChange"/>
                <label  class="side-label" :for="id">
                    <span v-if="mode === 'switch' && !!switch_options" class="switch--on">{{switch_options.on}}</span>
                    <span v-if="mode === 'switch' && !!switch_options" class="switch--off">{{switch_options.off}}</span>
                    <span v-if="mode === 'default' || mode === 'toggle'">
                        <template v-if="hasHtmlDescription">
                            <span v-html="description"></span>
                        </template>
                        <template v-else>
                            {{description}}
                        </template>
                        <slot name="addendum"></slot>
                        <span
                            v-if="!!helpText && helpTextPosition === 'description'"
                            style="display: inline-block; cursor: pointer"
                            :data-popover-title="description"
                            :data-popover-content="helpText"
                            class="np-popover helpBtn addPopover helpHeader">
                            <i tabindex="-1" class="fa fa-info-circle"></i>
                        </span>
                        <span
                            v-if="!!helpText && helpTextPosition === 'label'"
                            style="display: inline-block; cursor: pointer"
                            :data-popover-title="label"
                            :data-popover-content="helpText"
                            class="np-popover helpBtn addPopover helpHeader">
                                <i tabindex="-1" class="fa fa-info-circle"></i>
                        </span>
                    </span>
                </label>
            </div>
            <div :class="`form-group vue-radio-checkbox ${mode} np-checkbox`" v-else-if="mode === 'button'">
                <input type="checkbox"
                       :checked="is_checked"
                       :value="modelValue"
                       :id="id"
                       ref = 'input'
                       :name="name"
                       :disabled="disabled"
                       :required="isRequired"
                       :readonly="readonly"
                       v-bind="$attrs"
                       @change="doChange"/>
                <label  class="side-label btn" :for="id">
                    <span>
                        <template v-if="hasHtmlDescription">
                            <span v-html="description"></span>
                        </template>
                        <template v-else>
                            {{description}}
                        </template>
                        <slot name="addendum"></slot>
                        <span
                            v-if="!!helpText && helpTextPosition === 'description'"
                            style="display: inline-block; cursor: pointer"
                            :data-popover-title="description"
                            :data-popover-content="helpText"
                            class="np-popover helpBtn addPopover helpHeader">
                            <i tabindex="-1" class="fa fa-info-circle"></i>
                        </span>
                    </span>
                </label>
            </div>
            <div class="row" v-else>
                <div :class="`col-12 ${labelColMd}`">
                    <label>{{label}}</label>
                    <span
                        v-if="!!helpText && helpTextPosition === 'label'"
                        style="display: inline-block; cursor: pointer"
                        :data-popover-title="label"
                        :data-popover-content="helpText"
                        class="np-popover helpBtn addPopover helpHeader">
                            <i tabindex="-1" class="fa fa-info-circle"></i>
                    </span>
                </div>
                <div :class="`col-12 ${checkBoxColMd}`">
                    <div :class="`form-group vue-radio-checkbox ${mode} np-checkbox`">
                        <input type="checkbox"
                               :checked="is_checked"
                               :value="value"
                               :id="id"
                               ref = 'input'
                               :name="name"
                               :disabled="disabled"
                               :required="isRequired"
                               :readonly="readonly"
                               v-bind="$attrs"
                               @change="doChange"/>
                        <label  class="side-label" :for="id">
                            <span v-if="mode === 'switch' && !!switch_options" class="switch--on">{{switch_options.on}}</span>
                            <span v-if="mode === 'switch' && !!switch_options" class="switch--off">{{switch_options.off}}</span>
                            <span v-if="mode === 'default' || mode === 'toggle'">
                                <template v-if="hasHtmlDescription">
                                    <span v-html="description"></span>
                                </template>
                                <template v-else>
                                    {{description}}
                                </template>
                            </span>
                        </label>
                    </div>

                </div>
            </div>
        </div>
        <div v-else>
            <div class="form-group panel-sub-heading headingSmall">
                <span class="markedBottom">
                       <input type="checkbox"
                              :checked="is_checked"
                              :value="value"
                              :id="id"
                              ref = 'input'
                              :name="name"
                              :disabled="disabled"
                              :required="isRequired"
                              :readonly="readonly"
                              v-bind="$attrs"
                              @change="doChange"/>
                        <label class="side-label" :for="id">
                            <span v-if="mode === 'switch' && !!switch_options" class="switch--on">{{switch_options.on}}</span>
                            <span v-if="mode === 'switch' && !!switch_options" class="switch--off">{{switch_options.off}}</span>
                        </label>
                    <template v-if="hasHtmlDescription">
                        <span v-html="description"></span>
                    </template>
                    <template v-else>
                        {{description}}
                    </template>
                    <a v-if="!!popover"
                       data-popover-placement=""
                       :data-popover-title="!!popover.title ? popover.title : ''"
                       :data-popover-content="!!popover.content ? popover.content : ''"
                       href="#"
                       class="helpBtn addPopover helpHeader btn-sm">
                        <i tabindex="-1" class="fa fa-info-circle"></i>
                    </a>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
// todo: some legacy javascript add display:none to fa-check. Use v-if to deal with it but lose animation.
export default {
    name: 'np-checkbox',
    inheritAttrs: false,
    model: {
        prop: 'checked',
        event: 'change'
    },
    props: {
        id: String,
        name: String,
        checked: {
            default: '0'
        },
        helpText: {
            type: String,
            default :'',
        },
        helpTextPosition: {
            default: 'description' // 'description', 'label'
        },
        disabled: {
            default: false
        },
        readonly: {
            default: false
        },
        required: {
            default: false
        },
        mode: {
            default: 'default'   // default, sub_heading, panel_heading
        },
        hideBox: {
            default: false
        },
        fullLabel: {
            type: Boolean,
            default: false
        },
        invertCheck: {
            type: Boolean,
            default: false
        },
        popover: {
            default: () => {
                return false
            }   // example {'title': 'my title', 'content': 'my content'}
        },
        onSelected: Function,
        onDeselected: Function,
        value: String,
        modelValue: {
            type: null,
            default: '0'
        },
        label: String,
        noWrapper: Boolean,
        description: String,
        ariaLabel: String,
        rules: {
            type: Array,
            default: function () {
                return [];
            }
        },
        hasHtmlDescription: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.assignRules();
    },
    computed: {
        is_checked: function () {
            //return this.modelValue === '1';
            //check inversion sometimes checked can mean 0
            if(this.invertCheck){
                return this.modelValue === '0';
            }
            return this.modelValue === '1';
        },
        inputRef: function() {
            return this.$refs.input;
        },
        isRequired: function () {
            return !!this.required;
        },
        labelColMd: function(){
            if(this.fullLabel){
                return "col-md-12"
            }

            return "col-md-4"
        },
        checkBoxColMd: function(){
            if(this.fullLabel){
                return "col-md-12"
            }

            return "col-md-8"
        },
        checkOnValue: function(){
            //check inversion sometimes checked can mean 0
            if(this.invertCheck){
                return '0';
            }
            return '1'
        },
        checkOffValue: function(){
            //check inversion sometimes unchecked can mean 1
            if(this.invertCheck){
                return '1';
            }
            return '0'
        }
    },

    methods: {
        doChange($event) {
            this.$emit('update:modelValue', $event.target.checked ? '1' : '0')
            this.$emit('change', $event.target.checked ? '1' : '0');
            if($event.target.checked && !!this.onSelected){
                this.onSelected();
            } else if(!!this.onDeselected) {
                this.onDeselected();
            }
        },
        assignRules: function () {
            if(this.rules.length > 0) {
                this.rules.forEach(rule => {
                    if(typeof rule === 'string') {
                        this.inputRef.setAttribute(`data-rule-${rule}`, '');
                    } else {
                        for (const [key, value] of Object.entries(rule)) {
                            let excluded = ['maxlength', 'minlength', 'min', 'max'];
                            const rule_key = (excluded.findIndex(obj => {return obj === key}) > -1) ? key : `data-rule-${key}`;
                            if(typeof value === 'string') {
                                this.inputRef.setAttribute(rule_key, `${value}`);
                            } else {
                                if(value.hasOwnProperty('remove') && value.remove === true) {
                                    if(this.inputRef.hasAttribute(rule_key)) {
                                        this.inputRef.removeAttribute(rule_key)
                                        $(this.inputRef).rules('remove', key)
                                    }
                                }
                            }
                        }
                    }
                })
            }
        },
    }
}
</script>
